import { render, staticRenderFns } from "./RegisterView.yaml?vue&type=template&id=70bbe01f&component"
import script from "./RegisterView.yaml?vue&type=script&lang=ts&component"
export * from "./RegisterView.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports